<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M39 7h-5.5V5.5a1.5 1.5 0 00-3 0V7h-5V5.5a1.5 1.5 0 00-3 0V7h-5V5.5a1.5 1.5 0 00-3 0V7H9a2 2 0 00-2 2v30a2 2 0 002 2h30a2 2 0 002-2V9a2 2 0 00-2-2zm-24.5 3v1.5a1.5 1.5 0 003 0V10h5v1.5a1.5 1.5 0 003 0V10h5v1.5a1.5 1.5 0 003 0V10H38v6H10v-6zM10 38V19h28v19z"/></svg>